import * as Yup from 'yup';

export const StoreItemSchema = Yup.object().shape({
  item: Yup.string(),
  PurchasableCategory: Yup.string().required('Select at least one category!')
});
